import { Box, styled } from "@mui/material";

export const LogContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
});

export const LogHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`,
  minHeight: 48,
}));

export const LogContent = styled("pre")(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  overflow: "auto",
  backgroundColor: theme.palette.grey[100],
  fontFamily: "monospace",
  fontSize: "0.75rem",
  lineHeight: 1.5,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  flexGrow: 1,
}));

export const LogPanel = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  overflow: "hidden",
});
